<template>
    <div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'周计划审核'}]"/>
         <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>周计划信息</h1>
                                </div>
                                <div class="h-formLine weekplandetail18">
                                    <el-form :inline="true" :model="formInline" class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="提交人" class="h-elformWrap-2" style="margin-bottom: 0.2rem;">
                                            <el-input v-model="formInline.userName" placeholder="" readonly></el-input>
                                        </el-form-item>
                                        <!-- <el-form-item label="所在地址" class="h-elformWrap-2">
                                            <el-input v-model="formInline.areaName" placeholder="" readonly></el-input>
                                        </el-form-item> -->
                                        <el-form-item label="时间范围" class="h-elformWrap-2" style="margin-bottom: 0.2rem;">
                                            <el-col :span="11">
                                            <el-date-picker :clearable="false" type="date" placeholder="开始时间" v-model="formInline.starttime" style="width: 1.6rem;" readonly></el-date-picker>
                                            </el-col>
                                            <el-col :span="2">至&nbsp; </el-col>
                                            <el-col :span="11">
                                            <el-date-picker :clearable="false" type="date" placeholder="结束时间" v-model="formInline.endtime" style="width: 1.6rem;" readonly></el-date-picker>
                                            </el-col>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="h-rowBox" style="margin-top:30px;">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1 style="color:#222222;border:0">销售目标</h1>
                                    <div class="mubiaoBox">
										<div class="mubiao">
											<div class="mubiaobutton"></div>
											<div class="mubiaotext">已达成</div>
										</div>
										<div class="mubiao" style="margin-left:20px;">
											<div class="mubiaobutton" style="background:#fec02a"></div>
											<div class="mubiaotext">目标</div>
										</div>
									</div>
                                </div>
                                <div style="width:100%;height:1px;background:#dee1eb;margin-bottom:20px;"></div>
                                <div class="h-pieChart" id="h_line1Chart" style="width: 100%; height: 6.7rem;"></div>
                            </div>
                        </div>
                    </div> -->
                    <div class="h-rowBox ljjtimeselec" style="margin-top:30px;">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                                    <h1>周计划列表</h1>
                                </div>
                                <!-- <div style="width:100%;height:1px;background:#dee1eb;margin-bottom:20px;"></div> -->
                                <!-- <div class="weekplandetail18">
                                    <el-form :model="formLabelAlign" label-position="left" :rules="rules" ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                                        <el-form-item label="拜访时间" class="h-elformWrap-2" prop="time">
                                            <el-input v-model="formLabelAlign.time" placeholder="2019/09/06 至 2019/09/11"></el-input>
                                        </el-form-item>
                                        <el-form-item label="拜访类型" class="h-elformWrap-2" prop="bstyle">
                                            <el-input v-model="formLabelAlign.bstyle" placeholder="常规拜访"></el-input>
                                        </el-form-item>
                                        <el-form-item label="用户类型" class="h-elformWrap-2" prop="ystyle">
                                            <el-input v-model="formLabelAlign.ystyle" placeholder="医护人员"></el-input>
                                        </el-form-item>
                                        <el-form-item label="拜访对象" class="h-elformWrap-2" prop="duixiang">
                                            <el-input v-model="formLabelAlign.duixiang" placeholder="青岛大学附属医院"></el-input>
                                        </el-form-item>
                                        <el-form-item label="区域" class="h-elformWrap-2 wuxing">
                                            <el-input v-model="formLabelAlign.quyu" placeholder="山东省青岛市"></el-input>
                                        </el-form-item>
                                        <el-form-item label="渠道" class="h-elformWrap-2 wuxing">
                                            <el-input v-model="formLabelAlign.qudao" placeholder="渠道描述"></el-input>
                                        </el-form-item>
                                        <el-form-item label="备注" class="h-elformWrap-2 wuxing">
                                            <el-input v-model="formLabelAlign.beizhu" placeholder="用户购买意愿较强，标记持续跟踪"></el-input>
                                        </el-form-item>
                                    </el-form>
                                </div> -->
                                <el-table
                                    ref="multipleTable"
                                    :data="tableData3"
                                    @selection-change="handleSelectionChange"
                                    stripe
									border
                                    style="width: 100%"
                                    >
                                    <el-table-column
                                    type="index"
                                    width="40"
                                    label="#">
                                    </el-table-column>
                                    <el-table-column
                                    prop="times"
                                    label="拜访时间"
                                    width="400">
                                    <template scope="scope">
                                        <el-date-picker
                                        readonly
										 style="width: 100%;height: 0.3rem;"
                                         :clearable="false"
                                        v-model="scope.row.times"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        >
                                        </el-date-picker>
                                    </template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="euType"
									width="90"
                                    label="用户类型">
                                        <template scope="scope">
                                        <span v-if="scope.row.euType==1">经销商</span>
                                        <span v-if="scope.row.euType==2">用户</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="euName"
                                    label="拜访对象"
									 :show-overflow-tooltip="true"
                                    min-width="200">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.euName}}
										</div>
									</template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="contactDept"
                                    label="部门/科室"
									 :show-overflow-tooltip="true"
                                    width="100">
                                    </el-table-column>
                                    <el-table-column
                                    prop="contact"
                                    label="联系人"
                                    width="80">
                                    </el-table-column>
                                    <el-table-column
                                    prop="contactPhone"
                                    label="联系人电话"
                                    width="120">
										<template slot-scope="scope">
											<div style="text-align: left;">
												{{scope.row.contactPhone}}
											</div>
										</template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="planRemark"
                                    label="洽谈内容"
									 :show-overflow-tooltip="true"
                                    min-width="200">
										<template slot-scope="scope">
											<div style="text-align: left;">
												{{scope.row.planRemark}}
											</div>
										</template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>

                    <div v-if="zstype" class="h-rowBox" style="margin-top:0.3rem;">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>审批意见</h1>
                                </div>
								<el-form :model="formLabelAlign" label-position="right" :inline="true"
                                    class="demo-ruleForm h-formbLine inputO">
									<el-form-item label="审批意见" class="h-elformWrap-2 " :required="flaag"
                                             style="margin-bottom: 0.2rem;">
										<el-input v-model="formLabelAlign.checkMsg" placeholder="请输入"
                                            class="zidaoO"></el-input>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
				</div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60" style="margin-bottom:40px;">
            <div class="apprButton">
                    <el-row>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="cancel">返回</el-button>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bgred el-button--default" @click="refuse">驳回</el-button>
                        <el-button v-if="zstype" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="pass">通过</el-button>
                    </el-row>
                </div>
                <el-button v-if="!zstype"  @click="cancel" class="h-btn h-bBtn h-bgwhite">返回</el-button>
                <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                <el-button v-if="!zstype"
                        size="small" class="h-btn h-bBtn "
                        @click="genzongLiuch">
                    跟踪审批
                </el-button>
        </div>
        </div>
</template>
<script>
import ss from '../../api/SystemService';
export default {
    data(){
        return{
            instid:null,
            showhistory:false,
            all: "全部",
            formInline:{
				names:'',
				date1:'',
				date2:'',
            },
            zstype:false,
            flaag: true,
            tableData3: [],
            formLabelAlign:{},
            rules:{
                time: [
                    { required: true, message: '请输入拜访时间', trigger: 'blur' },
                ],
                bstyle: [
                    { required: true, message: '请输入拜访时间', trigger: 'blur' },
                ],
                ystyle: [
                    { required: true, message: '请输入拜访时间', trigger: 'blur' },
                ],
                duixiang: [
                    { required: true, message: '请输入拜访时间', trigger: 'blur' },
                ],
            }
        }
    },
    methods:{
        genzongLiuch(){
            this.showhistory = true;
        },
        lineChart1(){
            let lineChart1 = this.$echarts.init(document.getElementById('h_line1Chart'));
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                // legend: {
                // 	data: ['已达成', '目标'],
                // 	x:"right",
                // 	y:"top"
                // },
                grid: {
                    left: 50,
                    right: 50,
                    bottom: 50,
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['华北地区','东北地区','京津地区','珠三角地区','西北地区','西南地区'],
                    boundaryGap: [0, 0.01],

                    show : true,
                },
                yAxis: {
                    type: 'value',
                    show : true,
                },
                series: [
                    {
                        name: '已达成',
                        type: 'bar',
                        barGap:'0',
                        barWidth: '10%',
                        data: [18203, 23489, 29034, 104970, 131744, 630230],
                        itemStyle:{
                            normal:{
                                color:"#4f8bfe"
                            }
                        }
                    },
                    {
                        name: '目标',
                        type: 'bar',
                        barGap:'0',
                        barWidth: '10%',
                        data: [19325, 23438, 31000, 121594, 134141, 681807],
                        itemStyle:{
                            normal:{
                                color:"#fec02a"
                            }
                        }
                    }
                ]

            }
            lineChart1.setOption(option);
        },
        handleSelectionChange(){},
        initWeek(){

            if(this.$route.query.taskstatus==0){
                this.zstype=true;
            }
            this.instid = this.$route.query.instid;
            //初始化获取计划数据
            var id=this.$route.query.ywid;
            var plan={"careWeek":id,"planStatus":1};
            if(this.$route.query.taskstatus&&this.$route.query.taskstatus==1){
                //代办已审核的查看页
                plan={"careWeek":this.$route.query.ywid};
            }

            //查询这个用户提交审核的周计划
            ss.UserCare.weekPlanDetailFirst(plan).then(rd => {
                console.log("初始化计划",rd);
                this.formInline.area = rd.map.planWeek.areaCode;
                this.formInline.userName = rd.map.planWeek.cuname;
                this.formInline.areaName = this.$getDictName('YLRegion', rd.map.planWeek.areaCode);
                this.formInline.starttime=rd.map.planWeek.weekPlanStart.split(' ')[0];
                this.formInline.endtime=rd.map.planWeek.weekPlanEnd.split(' ')[0];
                this.formInline.careWeek=id;
                if(rd.map.planDraft&&rd.map.planDraft.length>0){
                    this.tableData3=rd.map.planDraft;
                    this.tableData3.forEach((item, index)=>{
                       item.times=[item.planTimeStart,item.planTimeEnd];
                    })
                }
                console.log("初始化计划",this.formInline);
            })
        },
        //用户审核
        usercheck(x) {
            this.formLabelAlign.careWeek=this.$route.query.ywid;
            this.formLabelAlign.taskid=this.$route.query.taskid;
            this.formLabelAlign.planStatus=x;
            ss.UserCare.checkPlanWeek(this.formLabelAlign).then(rd => {
                this.$store.dispatch('searchTasktotal');
                this.$msg.alerts("提交成功！",()=>{
                    this.$router.go(-1);
                })
            });
        },
        //通过按钮
        pass() {
            this.usercheck(2)
        },

        //驳回按钮
        refuse() {
            console.log(this.formLabelAlign.checkMsg,"sss");
            if(!this.formLabelAlign.checkMsg){
                this.$msg.msge("请填写审批意见");
            }else{
                this.usercheck(3)
            }
        },

        //取消按钮
        cancel() {
            this.$router.go(-1);
        },

    },
    mounted(){
        //this.lineChart1();
        this.initWeek();
    }
}
</script>

<style scoped>
.apprButton{
    margin-left: 50px;
}
.mubiaoBox{
	display: flex;
	justify-content: center;
}
.mubiaoBox .mubiao{
	display: flex;
	justify-content: center;
	align-items: center;
}
.mubiaoBox .mubiao .mubiaobutton{
	width: 30px;
	height: 18px;
	background: #4f8bfe;
}
.mubiaoBox .mubiao .mubiaotext{
	margin-left: 20px;
	color: #595959;
	font-size: 14px;
}
</style>
<style>
.weekplans .h-formBorder .el-input__inner{
    border: 0;
    border-bottom: 1px solid #d1d1d1;
}
.weekplans .h-formBorder .el-form-item__content{
    width: 70%;
}
.weekplandetail18 .h-formbLine .el-form-item__label{
    width: 22%;
    text-align: right;
}
.h-formbLine .el-form-item__label {
    width: 20%;
}
.weekplandetail18 .h-formbLine .h-elformWrap-2{
    width: 33.333%;
    padding-right: 0.5rem
}
.weekplandetail18 .h-formbLine .el-form-item__content{
    width: 78%;
}
.pass {
    background-color: #006aca;
    color: white;
    padding: 0.18rem 0.42rem;
}

.refuse {
    background-color: #24b5b8;
    color: white;
    padding: 0.18rem 0.42rem;
}

.ljjtimeselec .el-date-editor .el-range__icon{
	line-height: 0.22rem;
}
.ljjtimeselec .el-date-editor .el-range-separator{
	width: 8%;
	line-height: 0.23rem;
}
</style>
